// Formularfelder der Wallpaper-Einstellungen: Regler, Auswahl und Häkchen, gebunden an den Controller.
import { h, type VNode } from 'snabbdom';
import type { WallpaperSettings } from '../api';
import type { WallpaperCtrl } from './wallpaper';

export function range(c: WallpaperCtrl, key: 'secondsPerMove' | 'endPauseSeconds' | 'boardSize' | 'brightness' | 'boards', label: string, min: number, max: number, step: number, fmt: (v: number) => string, hint?: string): VNode {
  const v = c.settings![key];
  return h('div.fld', [
    h('div.row', [h('label', { attrs: { for: `wp-${key}` } }, label), h('output', fmt(v))]),
    h('input', {
      attrs: { id: `wp-${key}`, type: 'range' },
      // Grenzen vor dem Wert setzen, sonst klemmt der Browser den Wert auf 0…100
      props: { min: String(min), max: String(max), step: String(step), value: String(v) },
      on: { input: (e: Event) => c.set(key, +(e.target as HTMLInputElement).value) },
    }),
    hint ? h('span.muted.small', hint) : null,
  ]);
}

export function select<K extends 'position' | 'theme' | 'animation' | 'afterGame' | 'pieces' | 'mode'>(c: WallpaperCtrl, key: K, label: string, options: [WallpaperSettings[K], string][]): VNode {
  return h('div.row', [
    h('label', { attrs: { for: `wp-${key}` } }, label),
    h('select', {
      attrs: { id: `wp-${key}` },
      on: { change: (e: Event) => c.set(key, (e.target as HTMLSelectElement).value as WallpaperSettings[K]) },
    }, options.map(([v, t]) => h('option', { attrs: { value: v }, props: { selected: c.settings![key] === v } }, t))),
  ]);
}

export function check(c: WallpaperCtrl, key: 'showNames' | 'showYear' | 'showMove' | 'showLastMove' | 'showCoordinates' | 'pauseOnBattery', label: string): VNode {
  return h('label.chk', [
    h('input', { attrs: { type: 'checkbox' }, props: { checked: c.settings![key] }, on: { change: (e: Event) => c.set(key, (e.target as HTMLInputElement).checked) } }),
    ' ' + label,
  ]);
}
